import { Component, Story, Knobs, Accents } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  label: {
    default: 'Annual Leave',
    editor: 'textbox',
  },
  value: {
    default: 14,
    editor: 'number',
  },
  accent: {
    default: 'dolphinblue',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  orientation: {
    default: 'vertical',
    editor: 'dropdown',
    editorOptions: ['vertical', 'horizontal'],
  },
};

const PlaygroundKnobsV3: Knobs = {
  ...PlaygroundKnobs,
  colourScheme: {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A tag-stat where you can change all the attributes',
  coreComponent: {
    html: `<tag-stat style='width:350px;'{{...knobs}}>
</tag-stat>`,
    knobs: PlaygroundKnobs,
  },
  coreComponent_v3: {
    html: `<tag3-stat style='width:350px;'{{...knobs}}>
</tag3-stat>`,
    knobs: PlaygroundKnobsV3,
  },
  reactWrapper: {
    jsx: `<TagStat style={{ width: '350px' }}{{...knobs}} />`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Stat style={{ width: '350px' }}{{...knobs}} />`,
    knobs: PlaygroundKnobsV3,
  },
};

export const TagStatDocs: Component = {
  type: 'component',
  name: 'stat',
  description: 'Renders a statistic',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'accent',
      default: 'dolphinblue',
      description: 'The background colour',
      type: 'string',
    },
    {
      name: 'label',
      description: 'The label',
      type: 'string',
    },
    {
      name: 'value',
      description: 'The value',
      type: 'string',
    },
    {
      name: 'orientation',
      default: 'vertical',
      description: 'Whether the value is under the label (vertical) or at the side (horizontal)',
      type: 'vertical | horizontal',
    },
    {
      name: 'colourScheme',
      description:
        'V3 Only: Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'device',
      description: 'V3 Only: Set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [PlaygroundStory],
};
